import { render } from "./FullScreenModal.vue?vue&type=template&id=4c632b84"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__